import { Link } from "react-router-dom"
import { Button } from "@components/ui/button"
import { User } from "lucide-react"
import { useGetAccountExistsQuery } from "@apis/accounts/useAccounts"

type TButtonProps = {
  membership_profile_id: string | undefined
  account_id: number | undefined
  market_code?: string | null
  account_number?: string | null
}

export const AccountDetailsButton = ({
  membership_profile_id,
  account_id,
  market_code,
  account_number,
}: TButtonProps) => {
  const queryParams =
    (!membership_profile_id || !account_id) && market_code && account_number
      ? {
          account_number,
          market_code,
          ignore_status_group: true,
        }
      : undefined

  const getAccountExistsQuery = useGetAccountExistsQuery(queryParams)

  if (
    (!membership_profile_id || !account_id) &&
    !getAccountExistsQuery.data?.exists
  ) {
    return <p className="tw:italic">No Account Found</p>
  }

  const getAccountLink = () => {
    if (membership_profile_id && account_id)
      return `/profiles/${membership_profile_id}/accounts/${account_id}`

    return `/profiles/${getAccountExistsQuery.data?.membership_profile_id}/accounts/${getAccountExistsQuery.data?.account_id}`
  }

  return (
    <Button
      className={"tw:text-primary-foreground! tw:hover:no-underline!"}
      asChild
    >
      <Link to={getAccountLink()} target="_blank">
        <span>
          <User />
        </span>
        <span>Details</span>
      </Link>
    </Button>
  )
}
